module.exports = __webpack_public_path__ + "img/title-bg.0dea12d3.png";